import { InjectionToken } from '@angular/core';

import { WalletConnector } from '../models';

/** Provides the active wallet connector implementation behind a stable app-wide token. */
export const WALLET_CONNECTOR = new InjectionToken<WalletConnector>('Wallet connector');
